

<template>
<div>
  <h4 class="mb-0 text-primary">Features</h4>
  <hr class="mt-1"/>
  <ul class="row mb-0 list-unstyled">
    <li class="col-sm-6 mb-1 col-lg-4">
      <span>✔️</span> <span>{{calculateDeliveryTime(item.delivery_time)}} Delivery</span>
    </li>
    <li class="col-sm-6 mb-1 col-lg-4">
      <span>✔️</span> <span>{{item.revisions}} Revisions</span>
    </li>
    <template v-for="(attribute, index) in attributes">
      <li class="col-sm-6 mb-1 col-lg-4" v-if="attribute.type == 'check' && supports[attribute.id] == 'supported'"  :key="index">
        <span>✔️</span> <span>{{attribute.name}} </span>
      </li>
      <li class="col-sm-6 mb-1 col-lg-4" v-if="attribute.type == 'input' && supports[attribute.id]"  :key="index">
        <span>✔️</span>
        <span> {{supports[attribute.id]}} {{attribute.name}} </span>
      </li>
    </template>
  </ul>
</div>
</template>

<script>
export default {
    name: "package-features",
    props: {
      item: {
        type: Object,
        required: true,
      },
      attributes: {
        type: Array,
        default:() => ([]),
      },
    },
    computed:{
      supports(){
        return this.item.attributes || {};
      }
    }
}
</script>
